import styled from 'styled-components'

export const BreadcrumbsList = styled.ol`
  max-width: 100%;
  overflow-x: scroll;
  gap: 0.5rem;
  margin: 0;
  padding: 0 0 1.5rem 0;
  display: flex;

  li {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
  }

  @media (min-width: 992px) {
    padding: 1.5rem 0;
    max-width: var(--grid-max-width);
    overflow-x: initial;
    margin: 0 auto;
  }

  &::-webkit-scrollbar {
    height: 0;
  }
`
